import { getIconStyle } from "./icon-helper";
import { Props } from "./sy-icons-interface";
import styleSheet from "./style.module.scss";

const SyIcon = ({
  name,
  iconType = "icons",
  iconStyle = "outlined",
  onClick,
  value,
  pointer,
  iconColor,
  className,
  loading = false,
  size = "sm",
}: Props) => {
  const onClickIcon = () => {
    if (onClick) onClick(value);
  };

  const iconClassName = `material-${iconType}${
    iconStyle ? "-" + getIconStyle(iconType, iconStyle) : ""
  } ${pointer ? "pointer" : ""} ${className}`;

  const syIconStyle = iconColor ? { color: iconColor } : {};

  return (
    <>
      {!loading ? (
        <span
          className={`${iconClassName} ${styleSheet[size]}`}
          onClick={onClickIcon}
          style={syIconStyle}
        >
          {name}
        </span>
      ) : (
        <>
          <div
            className={`${styleSheet[size]}  spinner-border`}
            role="status"
            style={{ color: iconColor }}
          ></div>
        </>
      )}
    </>
  );
};

export default SyIcon;
